/**
 * @generated SignedSource<<56edd03e66894242f37aeb54b2f0324c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_SidebarLayout_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
  readonly " $fragmentType": "main_issueNavigator_SidebarLayout_project";
};
export type main_issueNavigator_SidebarLayout_project$key = {
  readonly " $data"?: main_issueNavigator_SidebarLayout_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_SidebarLayout_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_SidebarLayout_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3677db84ecd2dbced7bad0d324d3bcc6";

export default node;
